<template>
    <el-dialog
        title="Export to CSV"
        :visible.sync="showForm"
        append-to-body>

        <el-row v-if="noFiltersSet">
            <el-col :span="24">
                <el-alert title="No filters set"
                          type="error"
                          description="There are no filters selected. Please select some filters before exporting to CSV."
                          show-icon
                          :closable="false"></el-alert>
            </el-col>
        </el-row>

        <el-row :gutter="20" v-if="!noFiltersSet">
            <el-col :span="12">
                <b class="d-block" style="padding-bottom:10px">Additional columns</b>
                <el-checkbox v-model="columns.billed" class="d-block">Billed/Not Billed</el-checkbox>
                <el-checkbox v-model="columns.cost" class="d-block">$ Cost</el-checkbox>
                <el-checkbox v-model="columns.referrer" class="d-block">Referrer</el-checkbox>
                <el-checkbox v-model="columns.source" class="d-block">Source</el-checkbox>
                <el-checkbox v-model="columns.custom_questions" class="d-block">Custom Questions</el-checkbox>
                <el-checkbox v-model="columns.job_id" class="d-block">Job ID</el-checkbox>
                <el-checkbox v-model="columns.campaign_name" class="d-block">Campaign</el-checkbox>
                <el-checkbox v-model="columns.ja_call_transfer" class="d-block">JA Call Transfer</el-checkbox>
                <el-checkbox v-model="columns.admin_description" class="d-block">Admin Title</el-checkbox>
            </el-col>
            <el-col :span="12">
                <b class="d-block" style="padding-bottom:10px">Additional columns for Calls</b>
                <template v-if="filters.appType !== '' && filters.appType !== 'is_call'">
                    <el-alert type="info" show-icon title="Calls are filtered out from the result." :closable="false"></el-alert>
                </template>
                <template v-else>
                    <el-checkbox v-model="columns.duration" class="d-block">Duration</el-checkbox>
                    <el-checkbox v-model="columns.tracking_phone" class="d-block">Tracking Phone Number</el-checkbox>
                </template>
            </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
            <btn :click="() => showForm = false" cssClass="btn-default" icon="fal fa-times">Close</btn>
            <btn :click="exportCsv" cssClass="btn-primary" v-if="!noFiltersSet">Download CSV</btn>
        </span>

    </el-dialog>
</template>

<script>
const defaultColumns = {
    billed: false,
    cost: false,
    referrer: false,
    source: false,
    custom_questions: false,
    job_id: false,
    campaign_name: false,
    duration: false,
    tracking_phone: false,
    ja_call_transfer: false,
    admin_description: false
};
export default {
    props: [
        'show',
        'filters',
    ],
    data() {
        return {
            columns: _.cloneDeep(defaultColumns),
        };
    },
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) {
                this.$emit('close');
            }
        },
        noFiltersSet() {
            return this.filters.appType === ''
                && this.filters.agent === ''
                && this.filters.campaign === ''
                && this.filters.email === ''
                && this.filters.from === ''
                && this.filters.job === ''
                && this.filters.state === ''
                && this.filters.maxCdlA === ''
                && this.filters.maxCdlXp === ''
                && this.filters.minCdlA === ''
                && this.filters.minCdlXp === ''
                && this.filters.name === ''
                && this.filters.phone === ''
                && this.filters.source == '-1'
                && this.filters.to === ''
                && this.filters.zip === '';
        },
    },
    methods: {
        reset() {
            this.columns = _.cloneDeep(defaultColumns);
        },
        exportCsv() {
            const self = this;
            return axios.get(url(`admin/employer/${self.filters.employerId}/download-apps-csv`), {
                params: { filters: self.filters, cols: self.columns },
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'apps.csv');
                document.body.appendChild(link);
                link.click();
                link.remove();
            }).finally(() => {
                self.reset();
                self.showForm = false;
            });
        },
    }
}
</script>
